var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"isencao-analise"},[_c('div',{staticClass:"coming-soon"},[_c('i',{staticClass:"fas fa-search"}),_c('h2',[_vm._v("Análise de Isenção")]),_c('p',[_vm._v("Esta funcionalidade está sendo implementada.")])])])
}]

export { render, staticRenderFns }